import React from 'react';

import { TextField } from '@material-ui/core';

import { NumberFormatCustom } from '../../common/helpers';

const Main = (props) => {

    const { portfolio, actions, itemKey } = props;

    const { contributions = [], fees = [] } = portfolio;

    const key = itemKey;

    const foundContributions = contributions.find(e => e.key === key) || {};
    const foundFees = fees.find(e => e.key === key) || {};

    const headingStyle = { fontSize: 16, fontWeight: 'bold' };
    const itemRow = { display: 'flex', margin: '5px 5px 20px 20px' };
    const textCell = { width: 300, margin: 10 };

    return <div >
        <div>
            <div style={headingStyle}>Contributions</div>
            <div style={itemRow}>
                <div style={textCell}> <TextField
                    value={foundContributions.contribution ? foundContributions.contribution : ''}
                    variant="outlined"
                    fullWidth
                    label={'Cash'}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                        inputProps: {
                            style: {
                                padding: 15,
                            }
                        }
                    }}

                    onChange={(event) => {
                        actions.setPortfolioContributionValue(props, portfolio.portfolioNumber, 'contribution', event.target.value, key);
                        // actions.setPortfolioItemValue(props, portfolio.portfolioNumber, "value", event.target.value, key);
                    }} />
                </div>
                <div style={textCell}> <TextField
                    value={foundContributions.securitiesTransferred ? foundContributions.securitiesTransferred : ''}
                    variant="outlined"
                    fullWidth
                    label={'Securities Contributed at MV'}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                        inputProps: {
                            style: {
                                padding: 15,
                            }
                        }
                    }}

                    onChange={(event) => {
                        actions.setPortfolioContributionValue(props, portfolio.portfolioNumber, 'securitiesTransferred', event.target.value, key);
                        // actions.setPortfolioItemValue(props, portfolio.portfolioNumber, "value", event.target.value, key);
                    }} />
                </div>
            </div>
            <div style={{ color: '#797878', fontSize: 14, marginLeft: 30, marginTop: -20, marginBottom: 20 }}>
                <p>
                    A Contribution is from the owner or a separate portfolio to the analyzed portfolio and can be in the form of cash or securities.  Manager fees paid directly by the owner and not taken directly from the portfolio requires a Contribution entry and a Fees entry.  Manager fees paid from the portfolio does not require a transfer entry.
                    </p>
            </div>
        </div>
        <div>
            <div style={headingStyle}>Withdrawals</div>
            <div style={itemRow}>
                <div style={textCell}> <TextField
                    value={foundContributions.cashWithdrawl ? foundContributions.cashWithdrawl : ''}
                    variant="outlined"
                    fullWidth
                    label={'Cash'}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                        inputProps: {
                            style: {
                                padding: 15,
                            }
                        }
                    }}

                    onChange={(event) => {
                        actions.setPortfolioContributionValue(props, portfolio.portfolioNumber, 'cashWithdrawl', event.target.value, key);
                        // actions.setPortfolioItemValue(props, portfolio.portfolioNumber, "value", event.target.value, key);
                    }} />
                </div>
                <div style={textCell}> <TextField
                    value={foundContributions.securitiesWithdrawn ? foundContributions.securitiesWithdrawn : ''}
                    variant="outlined"
                    fullWidth
                    label={'Securities Withdrawn at MV'}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                        inputProps: {
                            style: {
                                padding: 15,
                            }
                        }
                    }}

                    onChange={(event) => {
                        actions.setPortfolioContributionValue(props, portfolio.portfolioNumber, 'securitiesWithdrawn', event.target.value, key);
                        // actions.setPortfolioItemValue(props, portfolio.portfolioNumber, "value", event.target.value, key);
                    }} />
                </div>
            </div>
            <div style={{ color: '#797878', fontSize: 14, marginLeft: 30, marginTop: -20, marginBottom: 20 }}>
                <p>
                A Withdrawal is from the analyzed portfolio to the owner and can be in the form of cash or securities.
                    </p>
            </div>
        </div>
        <div>
            <div style={headingStyle}>Fees</div>
            <div style={itemRow}>
                <div style={textCell}> <TextField
                    value={foundFees.feePaidToManager ? foundFees.feePaidToManager : ''}
                    variant="outlined"
                    fullWidth
                    label={'Manager Fees'}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                        inputProps: {
                            style: {
                                padding: 15,
                            }
                        }
                    }}

                    onChange={(event) => {
                        actions.setPortfolioContributionValue(props, portfolio.portfolioNumber, 'feePaidToManager', event.target.value, key, 'fees');
                        // actions.setPortfolioItemValue(props, portfolio.portfolioNumber, "value", event.target.value, key);
                    }} />
                </div>
            </div>
        </div>
        <div style={{ color: '#797878', fontSize: 14 }}>
            <p>
                Cash or security transfers between the owner and the managed portfolio must be identified by date and standardized market value (MV).
                </p>
            <p>
                All values must be standardized by dividing the true amount by the portfolio value factor calculated for Step 3.
                </p>
        </div>
    </div>
}

export default Main;


// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/EditContribution.js